import { Button } from "@material-ui/core";
import styled from "styled-components";

export const DefaultButton = styled(Button)`
    box-shadow: none;
    :disabled{
        border: 1px solid #313C4E;
        color: #313C4E;
    }
`